<template>
    <div id="screenRotation">
        <h1>Переверните экран</h1>
        <img src="../../public/telephone.png" height="100%" width="82%"/>
    </div>
</template>

<script>
    export default {
        name: "screenRotation"
    }
</script>

<style scoped lang="scss">
    /*Компонент - ПоворотЭкрана (ScreenRotation) */
    #screenRotation{
        /*картинка*/
       img{
           padding: 10% 0;
           margin: auto;
           display: block;
       }
    }
</style>